import React, { useState, useEffect, useRef } from 'react';
import api from '../service/AxiosInstance';
import { Divider } from 'primereact/divider';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { printPDF } from '../service/PrintService';
import moment from 'moment';

const MaConso = () => {

    const dt = useRef(null);
    const [conso, setConso] = useState([]);
    const [exercices, setExcercices] = useState([]);
    const [annee, setAnnee] = useState(new Date().getUTCFullYear());
    const user_connect_local = localStorage.getItem("user_connect");
    const user_connect = JSON.parse(user_connect_local);


    useEffect(() => {

        api.get("Compta/Participant/Conso", {
            params: {
                matricule: user_connect.numcont,
                annee: annee
            }
        })
            .then(resp => {
                setConso(resp.data);


            });

    }, [annee]);

    useEffect(() => {

        api.get("Compta/Exercices2/" + user_connect.numcont)
            .then(res => { setExcercices(res.data) });

    }, []);


    const sumFreels = conso.reduce((sum, { freels }) => (sum + freels), 0);
    const sumDebit = conso.reduce((sum, { debit }) => (sum + debit), 0);
    const sumCredit = conso.reduce((sum, { credit }) => (sum + credit), 0);

    const formatCurrency = (value) => {
        return value.toLocaleString('fr-FR');
    }

    const freelsBodyTemplate = (rowData) => {
        return formatCurrency(rowData.freels);
    }
    const debitBodyTemplate = (rowData) => {
        return formatCurrency(rowData.debit);
    }
    const creditBodyTemplate = (rowData) => {
        return formatCurrency(rowData.credit);
    }

    const dateBodyTemplate = (rowData) => {
        return moment(rowData.datecompta).format("DD-MM-YYYY");
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Dropdown className='mr-2' value={annee} options={exercices} onChange={(e) => setAnnee(e.value)} placeholder="Exercice" />
                <Button label="Imprimer Extrait" icon="pi pi-print" className="p-button-success mr-2" onClick={() => { printPDF('Print/ExtraitDeCompte/' + user_connect.numcont + '/' + annee + '?docName=extraitcptepart') }} />
            </React.Fragment>
        )
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <span className="block text-green-500 font-medium mb-1 text-xl">Solde : {formatCurrency(sumDebit - sumCredit)}</span>
            </React.Fragment>
        )
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h3>Ma Situation </h3>
                    <Divider />
                    <div className="datatable-crud-demo">
                        <Toolbar className="mb-2 mt-2" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        <DataTable value={conso} ref={dt} size='small'
                            rowHover responsiveLayout='scroll'
                            paginator resizableColumns
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            rows={10} rowsPerPageOptions={[10, 15, 20]}>
                            <Column field='datecompta' header='Date' sortable body={dateBodyTemplate}></Column>
                            <Column field='numdoc' header='N° Document' sortable ></Column>
                            <Column field='libelle' header='Libellé' sortable ></Column>
                            <Column field='freels' header='Frais Réels' footer={formatCurrency(sumFreels)} body={freelsBodyTemplate} align='right' sortable bodyStyle={{ textAlign: 'right', fontWeight: 'bold' }}></Column>
                            <Column field='debit' header='QP Agent' footerStyle={{ color: 'red' }} footer={formatCurrency(sumDebit)} body={debitBodyTemplate} align='right' bodyStyle={{ color: 'red', textAlign: 'right', fontWeight: 'bold' }} sortable ></Column>
                            <Column field='credit' header='Remboursement' footerStyle={{ color: 'green' }} footer={formatCurrency(sumCredit)} body={creditBodyTemplate} align='right' bodyStyle={{ color: 'green', textAlign: 'right', fontWeight: 'bold' }} sortable ></Column>
                            <Column field='typebenef' header='Type Bénéf.' style={{ textAlign: 'center' }} sortable ></Column>
                            <Column field='benef' header='Bénéficiaire' sortable ></Column>
                            <Column field='fournisseur' header='Fournisseur.' sortable ></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(MaConso, comparisonFn);
